import { api } from 'common';

export const MirthMessageType = api.FlowDefinition.MirthMessageType;
export type MirthMessageType = api.FlowDefinition.MirthMessageType;

export const mirthDefaultMessages: Record<keyof typeof MirthMessageType, string> = {
  [MirthMessageType.Hl7]: `MSH|^~\\&|NOTABLE|NOTABLE|RECEIVING_APP|RECEIVING_FACILITY|20250101010100||ADT^A08|MSG00001|T|2.3
PID|1||12345^^^MRN||DOE^JOHN^^^^||19800101|M|||`,
  [MirthMessageType.Json]: `{
  "name": "John",
  "age": 30,
  "city": "New York"
}`,
  [MirthMessageType.X12]: `ISA*00*          *00*          *ZZ*NOTABLEENG      *ZZ*CNE      *230326*1200*^*00501*000000905*0*T*:~
GS*HN*NOTABLEENG*CNE*20250326*1200*905*X*005010X278~
ST*278*0001*005010X278~
BHT*0007*13*REF123456*20250326*1200~
HL*1**20*1~
NM1*P3*2*Referral Provider*****XX*1234567890~
HL*2*1*21*1~
NM1*1P*1*John*Doe****XX*9876543210~
REF*EI*123456789~
DTP*291*D8*20250326~
SE*9*0001~
GE*1*905~
IEA*1*000000905~`,
};
